import { useEffect, useRef, useState } from 'react'

import { Radio } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import MenuItem from '@material-ui/core/MenuItem'

import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import { Grid } from '@material-ui/core/'
import { useContext } from 'react'
import { AuthContext } from '../../context/Auth/AuthContext'
import useQueues from '../../hooks/useQueues'
import { i18n } from '../../translate/i18n'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import ButtonWithSpinner from '../ButtonWithSpinner'
import { DepartmentFilter } from '../DepartmentFilter'
import { InputFieldText } from '../InputFieldText'
import SelectInput from '../SelectInput'
import { TagsFilter } from '../TagsFilter'
import { UsersFilter } from '../UsersFilter'
import { useStyles } from './style'
import { QueueDepartmentSelect } from '../QueueDepartmentSelect'
// const filterOptions = createFilterOptions({
//   trim: true
// })

const FilterTicketModal = ({ modalOpen, onClose, onFilter }) => {
  // const history = useHistory()
  // const [options, setOptions] = useState([])
  const [, setQueues] = useState([])
  const [, setAllQueues] = useState([])
  const [loading] = useState(false)
  // const [searchParam, setSearchParam] = useState('')
  // const [selectedUser, setSelectedUser] = useState(null)
  // const [selectedQueue, setSelectedQueue] = useState('')
  const classes = useStyles()
  const { findAll: findAllQueues } = useQueues()
  const isMounted = useRef(true)

  //Adicionado filtros
  const { user } = useContext(AuthContext)
  const { profile } = user
  const [selectedTags, setSelectedTags] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
  const [selectedDepartament, setSelectedDepartament] = useState([])
  const [, setSelectedStatus] = useState('')
  const [filterGroups] = useState('')
  const [status, setStatus] = useState('open')
  const searchInputRef = useRef(null)

  const userQueueIds =
    user.queues && Array.isArray(user.queues) ? user.queues.map(q => q.id) : []
  const [selectedQueueIds] = useState(userQueueIds || [])
  // const [showTabGroups, setShowTabGroups] = useState(false)

  // const { getSetting } = useSettings()

  const [selectedTagObjects, setSelectedTagObjects] = useState([])
  const [selectedUserObjects, setSelectedUserObjects] = useState([])
  const [selectedDepartmentObjects, setSelectedDepartmentObjects] = useState([])

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (isMounted.current) {
      const loadQueues = async () => {
        const list = await findAllQueues()
        setAllQueues(list)
        setQueues(list)
      }
      loadQueues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleClose() {
    if (searchInputRef.current) {
      searchInputRef.current.value = ''
    }
    onClose()
  }

  const handleSaveTicket = async e => {
    e.preventDefault()
    const searchTerm = (searchInputRef.current?.value || '').trim()

    const filterData = {
      searchParam: searchTerm || undefined,
      status,
      showAll: true,
      users: selectedUsers.length ? JSON.stringify(selectedUsers) : undefined,
      tags: Array.isArray(selectedTags)
        ? JSON.stringify(selectedTags)
        : JSON.stringify([selectedTags]),
      queueIds: selectedQueueIds.length
        ? JSON.stringify(selectedQueueIds)
        : undefined,
      departaments: selectedDepartament.length
        ? JSON.stringify(selectedDepartament)
        : undefined,
      groups: filterGroups || undefined,
      displayData: {
        tags: selectedTagObjects.map(tag => ({ id: tag.id, name: tag.name })),
        users: selectedUserObjects.map(user => ({
          id: user.id,
          name: user.name
        })),
        departments: selectedDepartmentObjects.map(dept => ({
          id: dept.id,
          name: dept.name
        }))
      }
    }

    Object.keys(filterData).forEach(key => {
      if (filterData[key] === undefined || filterData[key] === '[]') {
        delete filterData[key]
      }
    })

    onFilter(filterData)
    onClose()
  }

  const handleSelectedTags = selecteds => {
    setSelectedTagObjects(selecteds)
    const tags = selecteds.map(tag => tag.id)
    setSelectedTags(tags)
  }

  const handleSelectedUsers = selecteds => {
    setSelectedUserObjects(selecteds)
    const users = selecteds.map(ticket => ticket.id)
    setSelectedUsers(users)
  }

  const handleSelectedDepartament = selecteds => {
    setSelectedDepartmentObjects(selecteds)
    const departaments = selecteds.map(ticket => ticket.id)
    setSelectedDepartament(departaments)
  }

  const handleSelectedStatus = status => {
    setSelectedStatus(status)
  }

  const handleStatusChange = event => {
    setStatus(event.target.value)
    handleSelectedStatus(event.target.value)
  }

  return (
    <Dialog
      open={modalOpen}
      onClose={handleClose}
      maxWidth="lg"
      scroll="paper"
      classes={{ paper: classes.dialog }}
    >
      <form onSubmit={handleSaveTicket}>
        <DialogTitle id="transferTicketModal" className={classes.dialogTitle}>
          {/* {i18n.t('transferTicketModal.title')} */}
          Filtrar
        </DialogTitle>
        <DialogContent dividers className={classes.dialogContent}>
          <Grid container spacing={1} columnSpacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <InputFieldText
                fullWidth
                label="Pesquisa"
                placeholder="Pesquise por protocolo, nome, telefone ou palavra-chave"
                variant="outlined"
                inputRef={searchInputRef}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TagsFilter
                onFiltered={handleSelectedTags}
                value={selectedTags}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              {profile === 'admin' && (
                <UsersFilter
                  label="Usuários"
                  onFiltered={handleSelectedUsers}
                  value={selectedUsers}
                />
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <QueueDepartmentSelect
                label="Departamentos"
                placeholder="Selecione os departamentos"
                includeAllOption={true}
                showBots={false}
                filterByIsBot={true}
                isMulti={true}
                disabled={loading}
                value={selectedDepartmentObjects}
                onChange={departments => {
                  handleSelectedDepartament(departments)
                }}
              />
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12}>
              <SelectInput
                label={'Grupos'}
                labelId="groups-label"
                value={filterGroups}
                onChange={e => setFilterGroups(e.target.value)}
              >
                <MenuItem value="">Ambos</MenuItem>
                <MenuItem value="true">Apenas Grupos</MenuItem>
                <MenuItem value="false">Apenas Contatos</MenuItem>
              </SelectInput>
            </Grid> */}
            <Grid item xs={12} sm={12} md={12}>
              <SelectInput
                label={'Status'}
                labelId="status-select-label"
                id="status-select"
                value={status}
                onChange={handleStatusChange}
              >
                <MenuItem value="">
                  <Radio checked={status === ''} className={classes.radio} />
                  Todos
                </MenuItem>
                <MenuItem value="open">
                  {' '}
                  <Radio
                    checked={status === 'open'}
                    className={classes.radio}
                  />
                  Ativos
                </MenuItem>
                <MenuItem value="closed">
                  <Radio
                    checked={status === 'closed'}
                    className={classes.radio}
                  />
                  Fechado
                </MenuItem>
                <MenuItem value="pending">
                  <Radio
                    checked={status === 'pending'}
                    className={classes.radio}
                  />
                  Pendente
                </MenuItem>
              </SelectInput>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonSecondary
            onClick={handleClose}
            disabled={loading}
            label={i18n.t('transferTicketModal.buttons.cancel')}
          />
          <ButtonWithSpinner type="submit" loading={loading}>
            Filtrar
          </ButtonWithSpinner>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default FilterTicketModal